<!-- 订单详情 -->
<template>
  <div class="order-details business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="order-details-main">
      <div class="order-status">
        <div class="order-status1">
          <div>订单号：{{ tableData.Osn }}</div>
          <div class="status-text">{{ tableData.StateName }}</div>
          <!-- <div v-if="tableData.IsInvoiced == false">
            <el-button size="small" @click="showInvoice">申请开票</el-button>
          </div>-->
          <div class="print" @click="printOrderDetails">
            <i class="fa fa-print"></i>打印订单
          </div>
        </div>
        <div class="order-status2">
          <!-- <div class="order-dur">{{ tableData.StateName }}</div> -->
          <el-steps :active="parseInt(tableData.OrderState)+1" align-center>
            <el-step v-bind:key="item" v-for="item in orderStates" :title="item"></el-step>
          </el-steps>
        </div>
      </div>
      <!--订单信息-->
      <el-card class="box-card order-msg-ctn">
        <div class="order-msg">
          <div class="receive-msg order-msg-item">
            <div class="order-msg-title">收货人信息</div>
            <div>
              <div class="key">收货人</div>
              <div class="value">{{ tableData.Consignee }}</div>
            </div>
            <div>
              <div class="key">地址</div>
              <div class="value">{{ tableData.Address }}</div>
            </div>
            <div>
              <div class="key">电话号码</div>
              <div class="value">{{ tableData.Mobile }}</div>
            </div>
          </div>
          <div class="send-msg order-msg-item">
            <div class="order-msg-title">配送信息</div>
            <div>
              <div class="key">配送方式</div>
              <div class="value">{{ tableData.ShipFriendName }}</div>
            </div>
            <div>
              <div class="key">运费</div>
              <div class="value">{{ tableData.ShipFee }}</div>
            </div>
          </div>
          <div class="pay-msg order-msg-item">
            <div class="order-msg-title">付款信息</div>
            <div>
              <div class="key">付款方式</div>
              <div class="value">{{ tableData.PaymentMethod }}</div>
            </div>
            <div>
              <div class="key">付款时间</div>
              <div class="value">{{ tableData.PayTime }}</div>
            </div>
            <div>
              <div class="key">商品总额</div>
              <div class="value">￥{{ tableData.GoodAmount | moneyHandle }}</div>
            </div>
            <div>
              <div class="key">应支付金额</div>
              <div class="value">￥{{ tableData.SurplusMoney | moneyHandle }}</div>
            </div>
            <!-- <div>
              <div class="key">优惠</div>
              <div class="value">
                ￥{{
                  (tableData.OrderAmount - tableData.SurplusMoney) | moneyHandle
                }}
              </div>
            </div>-->
          </div>
          <div class="invoice order-msg-item" style="border-right:none">
            <div class="order-msg-title">发票信息</div>
            <template v-if="tableData.InvoiceList">
              <template>
                <div v-bind:key="item" v-for="item in tableData.InvoiceList">
                  <div>
                    <div class="key">发票抬头</div>
                    <div class="value">{{ item.Title }}</div>
                  </div>
                  <div>
                    <div class="key">发票类型</div>
                    <div class="value">{{ item.TypeName }}</div>
                  </div>
                  <div class="InvoiceItem">
                    <div class="key">发票内容</div>
                    <div class="value">{{ item.InvoiceContent }}</div>
                  </div>
                </div>
              </template>
            </template>
            <div v-else>
              <div>暂无发票信息</div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div style="padding: 10px">
          <div class="table-ctn" v-if="tableData.GoodsList">
            <el-table :data="tableData.GoodsList" style="width: 100%">
              <el-table-column show-overflow-tooltip width="390" label="商品">
                <template slot-scope="scope">
                  <div>
                    <div>
                      <div class="shop-msg">
                        <div class="image-ctn shop-cover">
                          <img :src="downloadUrl + scope.row.ShowImg" :onerror="defaultImg" class />
                        </div>
                        <div>
                          <div
                            class="qp-name"
                            :title="scope.row.GoodsName"
                          >{{ scope.row.GoodsName }}</div>
                          <div style="color: #b2b2b2;padding-left: 10px">
                            <template
                              v-for="size in scope.row.SpecificationList"
                            >{{ size.AttrValueName }}</template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="Psn" label="商品编号">
                <template slot-scope="scope" show-overflow-tooltip>{{ scope.row.GoodCode }}</template>
              </el-table-column>
              <el-table-column label="价格">
                <template slot-scope="scope" show-overflow-tooltip>￥{{ scope.row.SellPrice }}</template>
              </el-table-column>
              <el-table-column label="商品数量">
                <template slot-scope="scope" show-overflow-tooltip>x{{ scope.row.Count }}</template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" :autoWidth="true">
                <template slot-scope="scope">
                  <div class="ops-ctn">
                    <el-button
                      v-if="permission.buyAgain"
                      @click="buyAgain(scope.row)"
                      size="mini"
                      type="text"
                    >{{ permission.buyAgain }}</el-button>
                    <!-- <el-button
                      v-if="
                        parseInt(tableData.OrderState) == 3 &&
                          permission.applyAfter
                      "
                      @click="gotoApplyDetails(scope.row.OrderGoodRId)"
                      size="mini"
                      type="text"
                    >
                      {{ permission.applyAfter }}
                    </el-button>-->
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="money-msg">
            <div>
              <div class="money-item">
                <span class="key">商品总额：</span>
                <span class="value">￥{{ tableData.GoodAmount }}</span>
              </div>
              <!-- <div class="money-item">
                <span class="key"
                  >优&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠：</span
                >
                <span class="value"
                  >￥{{
                    (tableData.OrderAmount - tableData.SurplusMoney)
                      | moneyHandle
                  }}</span
                >
              </div>-->
              <div class="money-item">
                <span class="key">运&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;费：</span>
                <span class="value">￥{{ tableData.ShipFee }}</span>
              </div>
              <div class="money-item all-money">
                <span class="key">应付总额：</span>
                <span class="value font-md">￥{{ tableData.SurplusMoney }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <!-- <div class="footerOps-ctn" v-if="permission.edit">
        <el-button
          class="buy-btn"
          v-if="tableData.State == 5 && permission.cancel"
          @click="showCancelOrder"
          >{{ permission.cancel }}</el-button
        >
        <el-button
          class="buy-btn btn-primary"
          v-if="tableData.State == 5 && permission.pay"
          @click="gotoPay"
          >{{ permission.pay }}</el-button
        >
        <el-button
          class="buy-btn btn-primary"
          v-if="tableData.State == 15 && permission.confirmReceipt"
          @click="receiveGoods"
          >{{ permission.confirmReceipt }}</el-button
        >
        <el-button
          class="buy-btn btn-primary"
          v-if="tableData.State == 20 && permission.comment"
          @click="gotoComment(1)"
          >去评价</el-button
        >
        <el-button
          class="buy-btn btn-primary"
          v-if="tableData.State == 25 && permission.commentAgain"
          @click="gotoComment(2)"
          >追加评价</el-button
        >
      </div>-->
    </div>
    <!--    发票    -->
    <el-dialog
      :close-on-click-modal="false"
      width="800px"
      title="开发票"
      :visible.sync="invoiceShow"
      :before-close="handleClose"
      append-to-body
    >
      <invoice ref="invoice" :orderId="invoiceOrderId" @closeInvoice="closeInvoice"></invoice>
    </el-dialog>
    <!--   取消订单     -->
    <el-dialog
      :close-on-click-modal="false"
      width="800px"
      title="取消订单"
      :visible.sync="cancelOrderShow"
      :before-close="handleClose"
      append-to-body
    >
      <cancelOrder @closeCancel="closeCancel" :cancelId="tableData.OrderId" ref="cancelOrder"></cancelOrder>
    </el-dialog>
    <el-dialog width="830px" title="现货订单" :visible.sync="printOrderDetailsShow">
      <printOrderDetails @closeDialog="closeDialog" :orderDetails="tableData"></printOrderDetails>
    </el-dialog>
  </div>
</template>
<script>
// import elTableColumn from "@/components/common/chjtablecolumn";
import breadcrumb from "@/components/common/breadcrumb";
import printOrderDetails from "@/components/business/shareInventory/printOrderDetails";
import invoice from "@/components/common/invoice";
import cancelOrder from "@/components/business/shopOrder/cancelOrder";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    invoice,
    cancelOrder,
    printOrderDetails,
    breadcrumb,
    // elTableColumn
  },
  data() {
    return {
      browseId: "",
      permission: {},
      printOrderDetailsShow: false,
      cancelOrderShow: false,
      orderStates: ["待付款", "待发货", "待收货", "已收货"],
      invoiceOrderId: "",
      invoiceShow: false,
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      stateSp: 0,
      tableData: {},
      searchData: {
        orderId: "",
        UserId: this.$util.getLocalStorage("userMsg").EmployeeId
      }
    };
  },
  mounted() {
    //订单状态:20等待付款；40确认中；60已确认；80备货中；100已发货；120已收货；140锁定；160取消；
    this.searchData.orderId = this.$route.query.OrderId;
    this.browseId = this.$route.query.OrderId;
    this.getTableData();
    this.permission = this.$util.getPermission(
      "shareInventoryPurchaseOrders"
    );
  },
  filters: {
    moneyHandle(value) {
      return parseFloat(value).toFixed(2);
    }
  },
  methods: {
    gotoComment(type) {
      this.$router.push(
        `/shop/comment?OrderId=${this.searchData.orderId}&type=${type}`
      );
    },
    // 确认收货
    receiveGoods() {
      let that = this;
      this.$util.elConfirm({
        content: "您确定要确认收货吗？",
        confirmMsg: "确认收货成功",
        confirm() {
          that.$util
            .axiosPost({
              url: "/api/ShareInventory/ConfirmOrderReceipt",
              data: {
                orderId: that.tableData.OrderId,
                UserId: that.searchData.UserId
              }
            })
            .then(() => {
              that.getTableData();
            })
            .catch(err => {});
        }
      });
    },
    // 关闭取消订单
    closeCancel() {
      this.cancelOrderShow = false;
      window.history.back(-1);
    },
    // 去付款
    gotoPay() {
      this.$router.push(`/shop/pay?osn=${this.tableData.Osn}`);
    },
    // 取消订单
    showCancelOrder() {
      this.cancelOrderShow = true;
    },

    // 获取数据
    getTableData() {
      this.$util
        .axiosGet({
          url: "/api/ShareInventory/GetSGoodsPurchaseOrderDetail",
          data: this.searchData
        })
        .then(res => {
          if (res.data) {
            this.tableData = res.data;
          }
        })
        .catch(err => {});
    },
    gotoApplyDetails(OrderGoodRId) {
      // let item = this.tableData;
      // if (!item.DetailList) {
      //   this.$util.warningMsg("该订单没有可申请售后的商品");
      //   return;
      // }
      // this.$router.push(
      //   `/business/service/afterApplyDetails?OrderType=5&OrderId=${
      //     item.OrderId
      //   }&OrderCode=${item.OrderCode}&OrderGoodRId=${
      //     OrderGoodRId ? OrderGoodRId : ""
      //   }`
      // );
    },
    // 跳转结算页面
    buyAgain(item) {
      this.$router.push(
        `/shareInventory/siOrderConfirm?goodsId=` +
          item.GoodsId +
          "&buyQuantity=" +
          item.Count
      );
    },
    // 显示开发票页面
    showInvoice() {
      this.invoiceOrderId = this.tableData.OrderId;
      this.invoiceShow = true;
    },
    handleClose() {
      this.$refs.invoice.clearData();
      this.invoiceShow = false;
    },
    closeInvoice() {
      this.$refs.invoice.clearData();
      this.invoiceShow = false;
    },
    // 返回上一页
    back() {
      window.history.back(-1);
    },
    printOrderDetails() {
      this.printOrderDetailsShow = true;
    },
    closeDialog() {
      this.printOrderDetailsShow = false;
    }
  }
};
</script>
<style lang="less" scoped>
.InvoiceItem {
  border-bottom: 1px solid @border3Color;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.footerOps-ctn {
  padding-top: 20px;
  text-align: right;
}
.goods-msg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
.goods-name {
  width: 200px;
}
.order-md {
  justify-content: space-between;
  margin-top: 10px;
}
.hg-goods-message {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.suit-gift-image-ctn {
  width: 70px;
  height: 70px;
  margin-left: 30px;
  img {
    max-width: 70px;
    max-height: 70px;
  }
}
.qp-name {
  width: 280px;
  margin-left: 10px;
}
.print {
  cursor: pointer;
}
.order-status {
  display: flex;
  background: @border4Color;
  padding: 20px;
  margin-bottom: 20px;
}

.order-status1 {
  width: 20%;
  border-right: 1px solid @border3Color;
  text-align: center;
  div {
    margin-bottom: 10px;
  }
}
.status-text {
  font-size: @font-lg;
  color: @theme2;
  font-weight: bold;
}

.order-status2 {
  width: 80%;
  padding: 20px;
}
.order-dur {
  padding-bottom: 20px;
}
.shop-msg {
  display: flex;
  align-items: center;
}
.money-msg {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}
.money-item {
  width: 182px;
  display: flex;
  justify-content: space-between;
  line-height: 2em;
  font-size: @font-sm;
  .key {
    flex-shrink: 0;
  }
}
.all-money {
  color: red;
}
.pingj-btn {
  width: 80px;
}
.ops-ctn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  button {
    margin-left: 0;
  }
}
.order-msg-ctn {
  padding: 10px;
  margin-bottom: 20px;
}
.order-msg {
  display: flex;
}
.order-msg-item {
  width: 25%;
  border-right: 1px solid @border4Color;
  padding: 0 10px;
  > div {
    display: flex;
    margin-top: 10px;
  }
  .key {
    width: 100px;
    flex-shrink: 0;
  }
  .value {
    line-height: 1.2em;
  }
}
.order-msg-title {
  font-size: @font-md;
}
</style>
